var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisibilityOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 2C3.818 2 1.1 3.98 0 6.773a7.526 7.526 0 007 4.773c3.182 0 5.9-1.98 7-4.773A7.526 7.526 0 007 2zm0 7.955A3.183 3.183 0 017 3.59a3.183 3.183 0 010 6.364zm0-5.091c-1.056 0-1.91.852-1.91 1.909 0 1.056.854 1.909 1.91 1.909s1.91-.853 1.91-1.91c0-1.056-.854-1.908-1.91-1.908z"
  })));
}
export default SvgVisibilityOn;